import React, { FC, PropsWithChildren, useCallback } from 'react';
import { Menu, MenuProps } from '@material-ui/core';
import { useMenuDropdown } from '../MenuProvider';

export type MenuDropdownProps = {
    /**
     * This parameter indicates whether the options list will be hidden if the user clicks outside the container.
     */
    hideWhenClickAway?: boolean;
} & Omit<MenuProps, 'open'>;

const MenuDropdown: FC<PropsWithChildren<MenuDropdownProps>> = ({ hideWhenClickAway = true, children, ...rest }) => {
    const ctx = useMenuDropdown();

    const handleClose = useCallback(() => {
        ctx.setVisibility(false);
    }, []);

    return (
        <Menu
            {...rest}
            aria-hidden={!ctx.visible}
            getContentAnchorEl={null}
            open={ctx.visible}
            anchorEl={ctx.anchorEl}
            onClose={handleClose}
            onClick={(event) => {
                if (hideWhenClickAway) {
                    handleClose();
                }
                if (rest.onClick) {
                    rest.onClick(event);
                }
            }}
        >
            {children}
        </Menu>
    );
};

export default MenuDropdown;
